/**
 * @generated SignedSource<<ad2edb904ea1d73487ee76380e6e6a2f>>
 * @relayHash 1e9a7ba03c42c739a3541609feb7fe46
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5fa9720677b0e537b90b065034bf1f315e31fd2c9887b18cce1908813f004189

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraReplaceIssueSearchViewFieldSetsInput = {
  after?: string | null | undefined;
  before?: string | null | undefined;
  context?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  inclusive?: boolean | null | undefined;
  nodes: ReadonlyArray<string>;
};
export type JiraIssueSearchViewFieldSetsContext = {
  issueContext?: JiraIssueSearchViewFieldSetsIssueContext | null | undefined;
  projectContext?: JiraIssueSearchViewFieldSetsProjectContext | null | undefined;
};
export type JiraIssueSearchViewFieldSetsIssueContext = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsProjectContext = {
  issueType?: string | null | undefined;
  project?: string | null | undefined;
};
export type JiraFieldSetsMutationInput = {
  replaceFieldSetsInput?: JiraReplaceIssueSearchViewFieldSetsInput | null | undefined;
  resetToDefaultFieldSets?: boolean | null | undefined;
};
export type main_replaceListViewFieldSetsMutation$variables = {
  amountOfColumns: number;
  fieldSetsInput?: JiraFieldSetsMutationInput | null | undefined;
  id: string;
  includeView: boolean;
  input?: JiraReplaceIssueSearchViewFieldSetsInput | null | undefined;
};
export type main_replaceListViewFieldSetsMutation$data = {
  readonly jira: {
    readonly replaceIssueSearchViewFieldSets: {
      readonly success: boolean;
      readonly view?: {
        readonly fieldSets: {
          readonly __id: string;
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly fieldSetId: string | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
          readonly totalCount: number | null | undefined;
          readonly " $fragmentSpreads": FragmentRefs<"ui_nativeIssueTable_NativeIssueTable_columns">;
        } | null | undefined;
        readonly hasDefaultFieldSets: boolean | null | undefined;
        readonly id: string;
        readonly viewId: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type main_replaceListViewFieldSetsMutation$rawResponse = {
  readonly jira: {
    readonly replaceIssueSearchViewFieldSets: {
      readonly success: boolean;
      readonly view: {
        readonly fieldSets: {
          readonly __id?: string;
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly displayName: string | null | undefined;
              readonly fieldSetId: string | null | undefined;
              readonly fieldSetPreferences: {
                readonly width: number | null | undefined;
              } | null | undefined;
              readonly fieldType: {
                readonly displayName: string | null | undefined;
              } | null | undefined;
              readonly fieldsMetadata: {
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly canBeConfigured: boolean | null | undefined;
                    readonly fieldId: string | null | undefined;
                  } | null | undefined;
                } | null | undefined> | null | undefined;
              } | null | undefined;
              readonly isPlaceHolderField?: boolean | null | undefined;
              readonly isSortable: boolean | null | undefined;
              readonly jqlTerm: string | null | undefined;
              readonly type: string | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
          readonly totalCount: number | null | undefined;
        } | null | undefined;
        readonly hasDefaultFieldSets: boolean | null | undefined;
        readonly id: string;
        readonly viewId: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type main_replaceListViewFieldSetsMutation = {
  rawResponse: main_replaceListViewFieldSetsMutation$rawResponse;
  response: main_replaceListViewFieldSetsMutation$data;
  variables: main_replaceListViewFieldSetsMutation$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": isJscIFCEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import isJscIFCEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-ifc-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "amountOfColumns"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsInput"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeView"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v5 = [
  {
    "kind": "Variable",
    "name": "fieldSetsInput",
    "variableName": "fieldSetsInput"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "success"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "viewId"
},
v9 = {
  "kind": "ScalarField",
  "name": "hasDefaultFieldSets"
},
v10 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "fieldSetSelectedState": "SELECTED"
    }
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "amountOfColumns"
  }
],
v11 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v12 = {
  "kind": "ScalarField",
  "name": "fieldSetId"
},
v13 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v14 = {
  "kind": "ScalarField",
  "name": "displayName"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "main_replaceListViewFieldSetsMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "JiraIssueSearchViewPayload",
            "kind": "LinkedField",
            "name": "replaceIssueSearchViewFieldSets",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "condition": "includeView",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "JiraIssueSearchView",
                    "kind": "LinkedField",
                    "name": "view",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      {
                        "args": (v10/*: any*/),
                        "concreteType": "JiraIssueSearchFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSets",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          {
                            "concreteType": "JiraIssueSearchFieldSetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraIssueSearchFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "FragmentSpread",
                            "name": "ui_nativeIssueTable_NativeIssueTable_columns"
                          },
                          (v13/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "main_replaceListViewFieldSetsMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "JiraIssueSearchViewPayload",
            "kind": "LinkedField",
            "name": "replaceIssueSearchViewFieldSets",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "condition": "includeView",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "JiraIssueSearchView",
                    "kind": "LinkedField",
                    "name": "view",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      {
                        "args": (v10/*: any*/),
                        "concreteType": "JiraIssueSearchFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSets",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          {
                            "concreteType": "JiraIssueSearchFieldSetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraIssueSearchFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "type"
                                  },
                                  (v14/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "jqlTerm"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "isSortable"
                                  },
                                  {
                                    "concreteType": "JiraFieldSetPreferences",
                                    "kind": "LinkedField",
                                    "name": "fieldSetPreferences",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "width"
                                      }
                                    ]
                                  },
                                  {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldsMetadata",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueSearchMetadataField",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "canBeConfigured"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "fieldId"
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "ClientExtension",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "isPlaceHolderField"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "JiraFieldType",
                                    "kind": "LinkedField",
                                    "name": "fieldType",
                                    "plural": false,
                                    "selections": [
                                      (v14/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v13/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "5fa9720677b0e537b90b065034bf1f315e31fd2c9887b18cce1908813f004189",
    "metadata": {},
    "name": "main_replaceListViewFieldSetsMutation",
    "operationKind": "mutation",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": isJscIFCEnabled_provider
    }
  }
};
})();

(node as any).hash = "466463d5818b0ea99c65ad6cd3e34d53";

export default node;
